module.exports = {


  // ********************************************************
  //
  // CHINESE
  //
  // ********************************************************
  zh: {
    page_title: 'NIKE突破速度挑战赛',
    loading: [
      [
        '你，就是我们一直寻找的',
        '疾速跑者'
      ],
      [
        '你正踏入意大利蒙扎赛车场'
      ],
      [
        '即将和BREAKING2运动员',
        '共同挑战人类极速'
      ],
      [
        'PEGASUS 34上脚',
        '决心燃爆'
      ]
    ],
    startCta: '开始挑战',
    volumeCta: '调高⾳量更带感',
    start: '挑战赛即刻开启',
    scrollCta: '疾速滑动屏幕',
    help: [
      '你敢再慢一点吗'
    ],
    slow: [
      '',
      '就这点本事？'
    ],
    fast: [
      '这速度可差点意思',
      '厉害！你已接近\nBREAKING 2 运动员'
    ],
    airport: '完成一半赛程',
    '10kmCta': '最后10公里\n不容减速',
    end: '谁说极限遥不可及？',
    result: {
      title: '你创造了新的速度传奇',
      percentile: {
        0: '超越全国',
        1: '的参赛者'
      },
      btn_again: '再跑⼀次',
      btn_share: '先去炫耀',
      share_content: '立即向场外朋友炫耀',
      btn_draw: '抽取定制T恤',
      btn_buy: '入手疾速装备',
      btn_tc: '活动条款'
    },
    share_cta: {
      wechat: [
        '点击右上角…',
        '速速炫耀战绩'
      ],
      browser: [
        '点击底部分享按钮',
        '果断炫耀'
      ]
    },
    share: {
      generic: {
        title: [
          '我刚在突破速度挑战赛中',
          '创造了新的传奇'
        ],
        subtitle: '谁都可以质疑极限',
        cta: '你来试试？'
      },
      named: {
        title: [
          '我刚在突破速度挑战赛中',
          '创造了新的传奇'
        ],
        subtitle: '谁都可以质疑极限',
        cta: '你来试试？'
      }
    },
    wechat: {
      generic: {
        title: '够胆！F1赛道上飙速马拉松，冲破人类极限',
        desc: '参与并有机会获得定制疾速装备',
        moments: '够胆！F1赛道飙速，冲破人类马拉松极限'
      },
      result: {
        title: '厉害了！我刚刚在F1赛场飙速马拉松！',
        desc: '不服来战',
        moments: '厉害了！我刚刚在F1赛场飙速马拉松'
      }
    },
    unsupported: '扫描或长按识别二维码\n与极限，来场速战速决',
    landscape: '竖起手机后\n再开始挑战'
  },







  // ********************************************************
  //
  // ENGLISH
  //
  // ********************************************************
  en: {
    page_title: 'Nike Feed of Speed',
    loading: [
      [
        'You are the one',
        'we have been searching for'
      ],
      [
        'Now entering',
        'Monza Circuit, Italy'
      ],
      [
        'Challenge human speed limit',
        'with the Breaking2 Athletes'
      ],
      [
        'Putting on',
        'Nike Air Zoom Pegasus 34'
      ]
    ],
    startCta: 'Start',
    volumeCta: 'Turn up the Volume',
    start: 'The challenge\nis about to begin',
    scrollCta: 'Scroll to run',
    help: [
      'Are you really this slow?'
    ],
    slow: [
      '',
      'This is all you\'ve got?'
    ],
    fast: [
      '',
      'Amazing! You are close\nto the Breaking2 athletes'
    ],
    airport: 'Half way there',
    '10kmCta': 'Last 10km\nGo faster!',
    end: 'Who said the limit\nis out of reach',
    result: {
      title: 'You created a new speed record',
      percentile: {
        0: 'You beat',
        1: 'of the competition'
      },
      btn_again: 'Run Again',
      btn_share: '先去炫耀',
      share_content: '',
      btn_draw: 'Win a Gear',
      btn_buy: 'Buy Now',
      btn_tc: 'Terms & Conditions'
    },
    share_cta: {
      wechat: [
        '点击右上角…',
        '速速炫耀战绩'
      ],
      browser: [
        '点击底部分享按钮',
        '果断炫耀'
      ]
    },
    share: {
      generic: {
        title: [
          'Feed of Speed',
          'I just created a new record'
        ],
        subtitle: 'Who said the limit is out of reach',
        cta: 'Take Challenge'
      },
      named: {
        title: [
          '我刚在突破速度挑战赛中',
          '创造了新的传奇'
        ],
        subtitle: '谁都可以质疑极限',
        cta: '你来试试？'
      }
    },
    wechat: {
      generic: {
        title: '够胆！F1赛道上飙速马拉松，冲破人类极限',
        desc: '参与并有机会获得定制疾速装备',
        moments: '够胆！F1赛道飙速，冲破人类马拉松极限'
      },
      result: {
        title: '厉害了！我刚刚在F1赛场飙速马拉松！',
        desc: '不服来战',
        moments: '厉害了！我刚刚在F1赛场飙速马拉松'
      }
    },
    unsupported: 'Please Visit this Page\nfrom Your Mobile',
    landscape: '竖起手机后\n再开始挑战'
  }

}




// WEBPACK FOOTER //
// ./src/i18n/messages.js